module.exports = __webpack_public_path__ + "static/media/tm2.ea16045c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ipd503/tm2.jpg
// module id = 179
// module chunks = 0